import { Box, Typography } from '@mui/material';
import useIsMobile from './hooks/useIsMobile';

interface PageLinkProps {
    text: string;
    image: string;
    link: string;
}

function PageLink(props: PageLinkProps) {
    const isMobile = useIsMobile();

    const smoothScroll = (id: string) => {
        const element = document.getElementById(id) as HTMLElement;

        if (element !== null) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                cursor: 'pointer',
                transition: 'all 0.2s',
                '&:hover': {
                    transform: 'scale(1.05)',
                    filter: 'brightness(1.2) drop-shadow(0 0 2px white)',
                },
            }}
            onClick={() => {
                smoothScroll(props.link);
            }}
        >
            {props.image !== '' &&
                <img
                    src={props.image}
                    alt={props.text}
                    style={{
                        width: isMobile ? 50 : 75,
                        height: isMobile ? 50 : 75,
                        margin: 'auto',
                    }}
                />
            }
            <Typography
                variant="h5"
                sx={{
                    marginTop: 1,
                    textAlign: 'center',
                    color: 'white',
                }}
            >
                {props.text}
            </Typography>
        </Box>
    );
}

export default PageLink;
